import {ServizioMensaEventoCalendarioType} from "../../core/api/generated";

export enum VisualizationCalendarModalEnum {
  PASTA_IN_BIANCO = 'PASTA IN BIANCO',
  ASSENZA_STUDENTE ='ASSENZA STUDENTE',
}

export interface CalendarioModificaOption {
  tipoEvento: ServizioMensaEventoCalendarioType;
  giorni: Array<string>;
}
